<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<h2 class="bd-title">Folder Settings</h2>
<p class="text-muted">
  <small><em>All fields are required unless specified optional</em></small>
</p>
@if (libraryCreateRulePattern == LibraryRule.PerRecord) {
<alert type="warning">
  <coso-alert-message>These settings are ignored when using <strong>per record</strong> library naming rule, since no folder is created.</coso-alert-message>
</alert>
}
<coso-select-input
  [control]="formGroup.controls.folderNamingRule"
  [inputText]="formText.folderNamingRule"
  [readonly]="(isReadOnly$ | async) || libraryCreateRulePattern == LibraryRule.PerRecord"
></coso-select-input>
@if (formGroup.controls.folderNamingRule.value == FolderNamingRule.Pattern && libraryCreateRulePattern != LibraryRule.PerRecord) {
<coso-text-input type="text" [control]="formGroup.controls.folderNamingPattern" [inputText]="formText.folderNamingPattern" [readonly]="isReadOnly$ | async"></coso-text-input>
}

<ng-template #folderNamingRulePopover>
  <p>The structure or pattern used to create folders in SharePoint.</p>
  <p><strong>Pattern:</strong> This rule will create one folder based on the pattern specified in <i>Folder Name</i> field.</p>
  <p><strong>Custom script:</strong> This rule will create one folder based on your LUA script. Implement <code class="text-primary">getFolderName()</code> function.</p>
</ng-template>
